import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { trackEvent } from '../lib/analytics';

const WHATSAPP_URL = 'https://wa.me/610487698671';

export const WhatsAppFloat = () => {
  const [showBubble, setShowBubble] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (dismissed) return undefined;
    const timer = setTimeout(() => setShowBubble(true), 4000);
    return () => clearTimeout(timer);
  }, [dismissed]);

  const openWhatsApp = (source) => {
    trackEvent('click_whatsapp_float', { location: source });
    window.open(WHATSAPP_URL, '_blank');
  };

  const closeBubble = (e) => {
    e.stopPropagation();
    setShowBubble(false);
    setDismissed(true);
  };

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-row-reverse items-center gap-3">
      {/* WhatsApp button */}
      <button
        type="button"
        onClick={() => openWhatsApp('floating_button')}
        aria-label="Chat with us on WhatsApp"
        data-testid="whatsapp-float-button"
        className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_rgba(37,211,102,0.45)] hover:bg-[#1ebe5b] hover:scale-110 active:scale-95 transition-all duration-300 shrink-0"
      >
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-60 animate-ping" aria-hidden="true" />
        <svg viewBox="0 0 32 32" className="relative w-8 h-8 fill-current" aria-hidden="true">
          <path d="M16.003 3.2c-7.06 0-12.79 5.73-12.79 12.79 0 2.26.59 4.46 1.71 6.4L3.2 28.8l6.57-1.72a12.74 12.74 0 0 0 6.23 1.59h.01c7.06 0 12.79-5.73 12.79-12.79 0-3.42-1.33-6.63-3.75-9.05a12.7 12.7 0 0 0-9.05-3.63zm0 23.31h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-3.9 1.02 1.04-3.8-.25-.39a10.57 10.57 0 0 1-1.62-5.64c0-5.86 4.77-10.63 10.64-10.63 2.84 0 5.51 1.11 7.52 3.12a10.56 10.56 0 0 1 3.11 7.52c0 5.87-4.77 10.64-10.63 10.64zm5.83-7.96c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.71.16-.21.32-.82 1.04-1 1.25-.18.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.58-.95-.85-1.59-1.9-1.78-2.22-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.55.16-.18.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.71-.97-2.34-.26-.62-.52-.54-.71-.55l-.6-.01c-.21 0-.55.08-.84.4-.29.32-1.1 1.08-1.1 2.63 0 1.55 1.13 3.05 1.29 3.26.16.21 2.22 3.39 5.38 4.76.75.32 1.34.51 1.8.66.76.24 1.44.21 1.98.13.6-.09 1.89-.77 2.16-1.52.27-.75.27-1.39.19-1.52-.08-.13-.29-.21-.61-.37z" />
        </svg>
      </button>

      {/* Invite bubble */}
      <div
        onClick={() => openWhatsApp('floating_bubble')}
        data-testid="whatsapp-float-bubble"
        role="button"
        aria-label="Chat with us on WhatsApp"
        className={`relative cursor-pointer select-none rounded-2xl rounded-br-sm bg-white pl-4 pr-8 py-2.5 shadow-xl ring-1 ring-black/5 transition-all duration-500 ${
          showBubble ? 'opacity-100 translate-x-0 pointer-events-auto' : 'opacity-0 translate-x-3 pointer-events-none'
        }`}
      >
        <p className="text-sm font-semibold text-[#1E3A5F] whitespace-nowrap">Need help?</p>
        <p className="text-xs text-gray-500 whitespace-nowrap">Chat with us on WhatsApp</p>
        <button
          type="button"
          onClick={closeBubble}
          aria-label="Dismiss"
          data-testid="whatsapp-float-bubble-close"
          className="absolute top-1.5 right-1.5 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};
